function getZoomSrc(image) {
  const srcset = image.getAttribute('srcset');
  if (srcset) {
    const candidates = srcset.split(',').map((part) => {
      const [url, width] = part.trim().split(/\s+/);
      return { url, width: parseInt(width, 10) || 0 };
    });
    candidates.sort((a, b) => b.width - a.width);
    if (candidates[0]?.url) return candidates[0].url;
  }

  return image.currentSrc || image.src;
}

function createOverlay(image) {
  const overlayImage = document.createElement('img');
  const zoomSrc = getZoomSrc(image);
  overlayImage.setAttribute('src', zoomSrc);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, zoomSrc);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  overlayImage.onerror = () => {
    toggleLoadingSpinner(image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, zoomSrc) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${zoomSrc}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement?.parentElement?.querySelector('.loading__spinner');
  loadingSpinner?.classList.toggle('hidden');
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const media = overlay.parentElement || image.parentElement;
  const container = (media || overlay).getBoundingClientRect();
  const ratio = image.naturalHeight && image.naturalWidth
    ? image.naturalHeight / image.naturalWidth
    : image.height / image.width;
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${(xPosition / container.width) * 100}%`;
  const yPercent = `${(yPosition / container.height) * 100}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${container.width * zoomRatio}px`;
}

function getSwiper(image) {
  return image.closest('.swiper')?.swiper || null;
}

function magnify(image, event, zoomRatio) {
  image.parentElement.querySelectorAll('.image-magnify-full-size').forEach((node) => node.remove());

  const overlay = createOverlay(image);
  const media = image.parentElement;
  const swiper = getSwiper(image);
  let allowLeave = false;

  if (swiper) {
    swiper.allowTouchMove = false;
  }

  const cleanup = () => {
    overlay.remove();
    image.style.opacity = '100%';
    if (swiper) swiper.allowTouchMove = true;
    media.removeEventListener('mouseleave', onMediaLeave);
  };

  const onMediaLeave = (leaveEvent) => {
    if (!allowLeave) return;
    if (leaveEvent.relatedTarget && media.contains(leaveEvent.relatedTarget)) return;
    cleanup();
  };

  overlay.onclick = (clickEvent) => {
    clickEvent.stopPropagation();
    cleanup();
  };
  overlay.onmousemove = (moveEvent) => moveWithHover(image, overlay, moveEvent, zoomRatio);
  media.addEventListener('mouseleave', onMediaLeave);

  const ready = overlayImageReady(overlay);
  ready.then(() => {
    if (!media.matches(':hover')) {
      cleanup();
      return;
    }

    moveWithHover(image, overlay, event, zoomRatio);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        allowLeave = true;
      });
    });
  });
}

function overlayImageReady(overlay) {
  return new Promise((resolve) => {
    const check = () => {
      if (overlay.parentElement) {
        resolve();
        return;
      }
      requestAnimationFrame(check);
    };
    check();
  });
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      magnify(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
